import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const getLeadById = async (leadId) => {
  try {
    const response = await mainAxios.get(
      `/v1/lead/byId/${leadId}`,
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const reAssignLeadByUuid = async (leadUuid) => {
  try {
    const response = await mainAxios.put(
      `/v1/leads-bradescard/lead/${leadUuid}/reasignacion`,
      {},
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getLeadsByFilters = async (filters) => {
  try {
    const response = await mainAxios.post(
      `/v1/bradescard/list/filtros`,
      filters,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};